module.exports = __webpack_public_path__ + "img/e86aba2.png";